import CartPanelActiveHotelTile from './CartPanelActiveHotelTile'
import CartPanelNeedsDatesTile from './CartPanelNeedsDatesTile'
import CartPanelDurationUnavailableTile from './CartPanelDurationUnavailableTile'
import type { CartPanelAccommodationItem } from '../hooks/useCartPanelItems'

interface Props {
  item: CartPanelAccommodationItem
  onToggleInclude: (item: CartPanelAccommodationItem) => void
  onSetDates: () => void
  onDelete: (item: CartPanelAccommodationItem) => void
  isStreaming: boolean
}

function CartPanelHotelTileDispatcher({
  item,
  onToggleInclude,
  onSetDates,
  onDelete,
  isStreaming,
}: Props) {
  switch (item.cartStatus) {
    case 'active':
    case 'not_synced':
    case 'selected_rate_unavailable':
    case 'property_sold_out':
      return (
        <CartPanelActiveHotelTile
          item={item}
          onToggleInclude={onToggleInclude}
          onDelete={onDelete}
          isStreaming={isStreaming}
        />
      )
    case 'needs_dates':
    case 'pending_hydration':
      return (
        <CartPanelNeedsDatesTile
          item={item}
          onToggleInclude={onToggleInclude}
          onSetDates={onSetDates}
          onDelete={onDelete}
          isStreaming={isStreaming}
        />
      )
    case 'duration_unavailable':
      return (
        <CartPanelDurationUnavailableTile
          item={item}
          onToggleInclude={onToggleInclude}
          onDelete={onDelete}
          isStreaming={isStreaming}
        />
      )
    default:
      return undefined
  }
}

export default CartPanelHotelTileDispatcher
